// Copyright ©️ 2026 eVolve MEP, LLC

import { strongEntries } from 'helpers/strongEntries';

export const autodeskAuthPath = 'autodesk-auth' as const;
/** This is the full URL Autodesk will redirect back to after authentication */
export const autodeskRedirectUri = `${window.location.origin}/${autodeskAuthPath}` as const;

export type AutodeskRedirectState = Partial<{
  /** May include search params, e.g. `/fabrication?bendId=xyz` */
  previousLoc: `${typeof window.location.pathname}${typeof window.location.search}`;
}>;

export const buildAutodeskStateVar = (state: AutodeskRedirectState): string =>
  btoa(
    strongEntries(state)
      .map(([key, val]) => `${key}:${val}`)
      .join(','),
  );

export const extractAutodeskStateVar = (stateString: string): AutodeskRedirectState => {
  try {
    return Object.fromEntries(
      atob(stateString)
        .split(',')
        .filter((v) => v.includes(':'))
        .map((v) => v.split(':')),
    ) as AutodeskRedirectState;
  } catch (e) {
    // oxlint-disable-next-line no-console
    console.error(e);
  }
  return {};
};
